import { render, staticRenderFns } from "./PersonProfileRecentHistoryOverview.vue?vue&type=template&id=77c66666&scoped=true&"
import script from "./PersonProfileRecentHistoryOverview.vue?vue&type=script&lang=js&"
export * from "./PersonProfileRecentHistoryOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c66666",
  null
  
)

export default component.exports